<template>
  <div class="flex">
    <!-- SIDEBAR -->
    <div
      id="app-sidebar-12"
      class="bg-white hidden lg:block flex-shrink-0 overflow-y-auto shadow rounded-xl transition-all duration-300 pr-5"
      :class="[isCollapsed ? 'w-[80px]' : 'w-[280px]']"
    >
      <div class="flex flex-col h-full">
        <!-- SCROLLABLE AREA -->
        <div class="overflow-y-auto">
          <!-- Logo and Collapse Button -->
          <div class="relative p-2">
            <div
              v-show="!isCollapsed"
              class="flex justify-center"
            >
              <Image
                :src="Logo"
                alt="Logo"
                width="150"
                class="p-2"
              />
            </div>
            <button
              v-tooltip.right="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
              class="absolute left-2 top-2 p-2 rounded-full hover:bg-gray-100 transition-colors duration-150"
              @click="toggleCollapse"
            >
              <i :class="['pi', isCollapsed ? 'pi-angle-right' : 'pi-angle-left']" />
            </button>
          </div>

          <!-- Search bar (hidden when collapsed) -->
          <div
            v-show="!isCollapsed"
            class="p-2"
          >
            <IconField icon-position="left">
              <InputIcon class="pi pi-search text-surface-700" />
              <InputText
                type="text"
                class="border !border-surface w-full !rounded-[30px]"
                placeholder="Search"
              />
            </IconField>
          </div>

          <!-- OFFICE -->
          <div class="px-2 pb-2">
            <router-link
              v-tooltip.right="isCollapsed ? 'Office' : null"
              to="/office"
              class="flex items-center gap-2 p-2 text-surface-900 hover:text-yellow-600 transition-colors duration-150"
            >
              <Image
                :src="Menu"
                alt="Office"
                class="flex-shrink-0"
                width="15"
              />
              <span
                v-show="!isCollapsed"
                class="font-medium"
              >OFFICE</span>
            </router-link>
            <div
              class="flex flex-col pl-4"
              :class="{ 'gap-2': isCollapsed }"
            >
              <router-link
                v-tooltip.right="isCollapsed ? 'Contacts' : null"
                to="/contacts"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent',
                  {
                    '!border-yellow-500 !text-yellow-600': isCollapsed && (
                      route.path === '/contacts' ||
                      route.path === '/services' ||
                      route.path === '/companies' ||
                      route.path === '/venues' ||
                      route.path === '/internal-staff' ||
                      route.path === '/freelance-staff' ||
                      route.path.startsWith('/view-contact/') ||
                      route.path.startsWith('/view-company/') ||
                      route.path.startsWith('/view-service/') ||
                      route.path.startsWith('/view-venue/')
                    ),
                    'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2': !isCollapsed && (
                      route.path === '/contacts' ||
                      route.path === '/services' ||
                      route.path === '/companies' ||
                      route.path === '/venues' ||
                      route.path === '/internal-staff' ||
                      route.path === '/freelance-staff' ||
                      route.path.startsWith('/view-contact/') ||
                      route.path.startsWith('/view-company/') ||
                      route.path.startsWith('/view-service/') ||
                      route.path.startsWith('/view-venue/')
                    )
                  }
                ]"
              >
                <Image
                  :src="Contact"
                  alt="Contacts Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Contacts</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Projects' : null"
                to="/projects"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Projects"
                  alt="Projects Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Projects</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Crewing' : null"
                to="/crewing"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Customers"
                  alt="Crewing Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Crewing</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Logistics' : null"
                to="/logistics"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Delivery"
                  alt="Logistics Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Logistics</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Shortages' : null"
                to="/shortages"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Income"
                  alt="Shortages Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Shortages</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Finance' : null"
                to="/finance/overview"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Income"
                  alt="Finance Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Finance</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Health and Safety' : null"
                to="/health-and-safety"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Income"
                  alt="H&S Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >H&S</span>
              </router-link>
            </div>
          </div>

          <!-- WAREHOUSE -->
          <div class="px-2 pb-2">
            <router-link
              v-tooltip.right="isCollapsed ? 'Warehouse' : null"
              to="/warehouse"
              class="flex items-center gap-2 p-2 text-surface-900 hover:text-yellow-600 transition-colors duration-150"
            >
              <Image
                :src="Menu"
                alt="Warehouse"
                class="flex-shrink-0"
                width="15"
              />
              <span
                v-show="!isCollapsed"
                class="font-medium"
              >WAREHOUSE</span>
            </router-link>
            <div
              class="flex flex-col pl-4"
              :class="{ 'gap-2': isCollapsed }"
            >
              <router-link
                v-tooltip.right="isCollapsed ? 'Assets' : null"
                to="/assets"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Assets"
                  alt="Assets Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Assets</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Operations' : null"
                to="/operations/returns"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Warehouse"
                  alt="Operations Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Operations</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Workshop' : null"
                to="/workshop"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Warehouse"
                  alt="Workshop Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Workshop</span>
              </router-link>
              <router-link
                v-tooltip.right="isCollapsed ? 'Wiki' : null"
                to="/wiki"
                :class="[
                  isCollapsed
                    ? 'w-full h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface hover:bg-surface-100 transition-colors duration-150 rounded-full'
                    : 'flex items-center cursor-pointer p-2 text-surface-700 hover:bg-surface-100 duration-150 transition-colors border-r-2 border-transparent'
                ]"
                :active-class="isCollapsed ? '!border-yellow-500 !text-yellow-600' : 'bg-yellow-50 text-yellow-600 border-yellow-500 border-r-2'"
              >
                <Image
                  :src="Edit"
                  alt="Wiki Icon"
                  :class="[isCollapsed ? '' : 'mr-2']"
                  width="15"
                />
                <span
                  v-show="!isCollapsed"
                  class="font-medium"
                >Wiki</span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Bottom buttons -->
        <div
          class="mt-auto border-t border-surface p-2 flex"
          :class="[isCollapsed ? 'flex-col gap-2' : 'justify-between']"
        >
          <router-link
            v-tooltip.right="isCollapsed ? 'Profile' : null"
            to="/profile"
            class="w-10 h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface 
                               hover:bg-surface-100 transition-colors duration-150 rounded-full no-underline text-inherit"
            aria-label="Profile"
          >
            <Image
              :src="Profile"
              alt=""
              role="presentation"
              class="px-2 pointer-events-none select-none"
              width="15"
              draggable="false"
            />
          </router-link>
          <router-link
            v-slot="{ href }"
            to="/notifications"
            custom
          >
            <a
              v-tooltip.right="isCollapsed ? 'Notifications' : null"
              :href="href"
              class="w-10 h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface 
                               hover:bg-surface-100 transition-colors duration-150 rounded-full relative no-underline text-inherit"
              aria-label="Notifications"
              @click="onNotificationsLinkClick"
            >
              <Image
                :src="NotificationIcon"
                alt=""
                role="presentation"
                class="px-2 pointer-events-none select-none"
                width="15"
                draggable="false"
              />
              <Badge
                v-if="notificationsStore.unreadCount > 0"
                :value="notificationsStore.unreadCount > 99 ? '99+' : notificationsStore.unreadCount"
                severity="danger"
                class="absolute -top-0.5 -right-0.5 min-w-[1.25rem] h-5 flex items-center justify-center text-xs pointer-events-none"
              />
            </a>
          </router-link>
          <button
            v-tooltip.right="isCollapsed ? 'Chat' : null"
            class="w-10 h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface 
                               hover:bg-surface-100 transition-colors duration-150 rounded-full"
            @click="openChatWindow"
          >
            <Image
              :src="Chat"
              alt="Chat Icon"
              class="px-2"
              width="15"
            />
          </button>
          <router-link
            v-tooltip.right="isCollapsed ? 'Settings' : null"
            to="/settings"
            class="w-10 h-10 cursor-pointer inline-flex items-center justify-center border-2 border-surface 
                               hover:bg-surface-100 transition-colors duration-150 rounded-full no-underline text-inherit"
            aria-label="Settings"
          >
            <Image
              :src="Settings"
              alt=""
              role="presentation"
              class="px-2 pointer-events-none select-none"
              width="15"
              draggable="false"
            />
          </router-link>
          <button
            v-tooltip.right="isCollapsed ? 'Log out' : null"
            class="w-10 h-10 cursor-pointer inline-flex items-center justify-center 
                               text-primary-contrast border-2 border-primary-emphasis hover:bg-primary-emphasis 
                               transition-colors duration-150 rounded-full"
            @click="showLogoutModal"
          >
            <Image
              :src="LogOut"
              alt="Logout Icon"
              class="px-2"
              width="15"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Notifications Drawer -->
    <Drawer
      v-model:visible="notificationDrawerVisible"
      position="right"
      header="Notifications"
      class="!w-full sm:!w-[22rem]"
      :dismissable="true"
    >
      <template #footer>
        <div
          v-if="notificationsStore.unreadCount > 0"
          class="flex justify-end"
        >
          <Button
            label="Mark all as read"
            size="small"
            text
            @click="notificationsStore.markAllAsRead()"
          />
        </div>
      </template>
      <NotificationsListContent :close-drawer="closeNotificationDrawer" />
    </Drawer>

    <!-- Confirmation Modal -->
    <div
      v-if="showModal"
      class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
    >
      <div class="bg-white p-6 rounded-lg shadow-lg w-1/3">
        <h3 class="text-lg font-semibold">
          Are you sure you want to log out?
        </h3>
        <div class="mt-4 flex justify-end space-x-4">
          <button
            class="px-4 py-2 bg-gray-200 rounded-md text-gray-700"
            @click="cancelLogout"
          >
            Cancel
          </button>
          <button
            class="px-4 py-2 bg-red-600 rounded-md text-white"
            @click="confirmLogout"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>

    <!-- Main content / slot -->
    <div class="flex-auto">
      <slot />
    </div>
  </div>
</template>

<script setup>
// Vue Router
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

// Image Imports
import Assets from '@/assets/icons/Assets.svg'
import Chat from '@/assets/icons/Chat.svg'
import Customers from '@/assets/icons/Customers.svg'
import Delivery from '@/assets/icons/Delivery.svg'
import Edit from '@/assets/icons/Edit.svg'
import Income from '@/assets/icons/Income.svg'
import Logo from '@/assets/logos/Symphony_Logo_Only.png'
import LogOut from '@/assets/icons/Logout.svg'
import Menu from '@/assets/icons/Menu.svg'
import NotificationIcon from '@/assets/icons/Notification.svg'
import Profile from '@/assets/icons/UserManagement.svg'
import Projects from '@/assets/icons/Projects.svg'
import Settings from '@/assets/icons/Settings.svg'
import Warehouse from '@/assets/icons/Warehouse.svg'
import Contact from '@/assets/icons/NewClient.svg'

import { useAuthStore } from '@/stores/authStore'
import { useNotificationsStore } from '@/stores/notificationsStore'
import router from "@/router";
import { useChatWindow } from '@/composables/useChatWindow';
import NotificationsListContent from '@/components/notifications/NotificationsListContent.vue';

const route = useRoute();
const notificationsStore = useNotificationsStore();
const showModal = ref(false);
const isCollapsed = ref(false);
const notificationDrawerVisible = ref(false);

// Chat window functionality
const { openChatWindow } = useChatWindow();

const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
};

const openNotificationDrawer = () => {
    notificationDrawerVisible.value = true;
    notificationsStore.loadNotifications();
};

/** Plain left-click opens the drawer; Ctrl/Cmd/Middle-click follows /notifications (new tab). */
const onNotificationsLinkClick = (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) {
        return;
    }
    e.preventDefault();
    openNotificationDrawer();
};

onMounted(() => {
    notificationsStore.loadNotifications();
});

const closeNotificationDrawer = () => {
    notificationDrawerVisible.value = false;
};

const showLogoutModal = () => {
    showModal.value = true;
};

const cancelLogout = () => {
    showModal.value = false;
};

const confirmLogout = async () => {
    try {
        console.log('Starting logout process...');
        const authStore = useAuthStore();
        console.log('Auth store before logout:', {
            isLoggedIn: authStore.isLoggedIn,
            hasToken: !!authStore.authToken,
            user: authStore.currentUser
        });
        
        await authStore.logout();
        
        console.log('Logout completed, redirecting to login...');
        router.push('/');
    } catch (error) {
        console.error('Logout failed:', error);
        // Show a user-friendly error message instead of console.error
        alert('Logout failed. Please try again.');
    }
    showModal.value = false;
};</script>

<style scoped>
/* Remove the old router-link-active style since we're using active-class now */
</style>
